import React, { useState } from 'react';
import moment from 'moment';
import './WStoreFilterCalendar.scss';

const WStoreFilterCalendar = ({ exactDate, handleSelectDate }) => {
  const [currentMonth, setCurrentMonth] = useState(exactDate || moment());

  const daysOfWeek = moment.weekdaysShort().map(day => day.slice(0, 2));
  const startOfMonth = currentMonth.clone().startOf('month');
  const daysInMonth = currentMonth.daysInMonth();
  const today = moment().startOf('day');
  const startDayOfWeek = startOfMonth.day();

  const handlePrevMonth = () => {
    setCurrentMonth(prev => prev.clone().subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    setCurrentMonth(prev => prev.clone().add(1, 'month'));
  };

  const handleDateClick = date => {
    if (date.isSameOrAfter(today, 'day')) {
      handleSelectDate(date);
    }
  };

  const renderDays = () => {
    const daysArray = [];

    for (let i = 0; i < startDayOfWeek; i++) {
      daysArray.push(<div key={`empty-${i}`} className="empty-cell"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = currentMonth.clone().date(day);
      const isSelected = exactDate && date.isSame(exactDate, 'day');
      const isFutureOrToday = date.isSameOrAfter(today, 'day');

      daysArray.push(
        <button
          type="button"
          key={day}
          className={`calendar-day ${isSelected ? 'selected' : ''} ${
            isFutureOrToday ? 'clickable' : 'disabled'
          }`}
          onClick={() => handleDateClick(date)}
        >
          {day}
        </button>
      );
    }

    return daysArray;
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button type="button" onClick={handlePrevMonth}>
          {'<'}
        </button>
        <div>{currentMonth.format('MMMM YYYY')}</div>
        <button type="button" onClick={handleNextMonth}>
          {'>'}
        </button>
      </div>
      <div className="calendar-body">
        <div className="calendar-days-header">
          {daysOfWeek.map(day => (
            <div key={day}>{day}</div>
          ))}
        </div>
        <div className="calendar-grid">{renderDays()}</div>
      </div>
    </div>
  );
};

export default WStoreFilterCalendar;
